import { call, put, takeLatest } from 'redux-saga/effects';
import { authService } from './auth.service';
import { LOG_IN, LOG_OUT, REGISTER, GET_MY_PROFILE, GET_MY_PROFILE_SUCCESS } from './auth.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { connectSocket, disconnectSocket } from '../../utils/socketManager';

function* logInSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(authService.login, payload);
    localStorage.setItem('access-token', res.data.token);
    connectSocket();
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put({ type: GET_MY_PROFILE });
    window.location.replace('/dashboard');
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message || 'Login failed'));
  }
}

function* logOutSaga() {
  disconnectSocket();
  localStorage.clear();
  window.location.replace('/login');
}

function* registerSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(authService.register, payload);
    localStorage.setItem('access-token', res.data.token);
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    window.location.replace('/dashboard');
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message || 'Registration failed'));
  }
}

function* getMyProfileSaga({ type }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(authService.getMyProfile);
    yield put({ type: GET_MY_PROFILE_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

export function* watchAuth() {
  yield takeLatest(LOG_IN, logInSaga);
  yield takeLatest(LOG_OUT, logOutSaga);
  yield takeLatest(REGISTER, registerSaga);
  yield takeLatest(GET_MY_PROFILE, getMyProfileSaga);
}
